<template>
  <div>
    <label style="font-weight: 600; color: #003366">
      {{ placeholder }}
    </label>
    <input
      :id="id"
      :type="type"
      class="cr_form_input"
      :placeholder="suggest"
      :value="value"
      @input="emitValue($event.target.value)"
      style="background-color: transparent;border: 0.5px solid black; border-radius: 5px; padding: 5px; font-family: 'Open Sans', sans-serif;"
    />
  </div>
</template>

<script>
export default {
  props: ["value", "type", "placeholder", "id", "suggest"],
  methods: {
    emitValue(value) {
      this.$emit("input", value);
    }
  }
};
</script>

<style scoped>
input:focus {
  outline: none;
}
</style>
